<style lang="less" rel="stylesheet/less" scope>
  .fallback-img {
    width: 100%;
    height: 100%;
  }
</style>
<template>
  <div class="fallback-img">
    <img :src="imageSrc" ref="img">
  </div>
</template>
<script type='text/ecmascript-6'>
  import icon1 from '@/assets/default-image/icon1.png';
  import icon2 from '@/assets/default-image/icon2.png';
  import icon3 from '@/assets/default-image/icon3.png';
  import icon4 from '@/assets/default-image/icon4.png';
  import icon5 from '@/assets/default-image/icon5.png';
  import icon6 from '@/assets/default-image/icon6.png';
  import icon7 from '@/assets/default-image/icon7.png';
  import icon8 from '@/assets/default-image/icon8.png';
  import icon9 from '@/assets/default-image/icon9.png';
  import icon10 from '@/assets/default-image/icon10.png';
  import icon11 from '@/assets/default-image/icon11.png';
  import icon13 from '@/assets/default-image/icon13.png';
  import icon14 from '@/assets/default-image/icon14.png';
  import icon15 from '@/assets/default-image/icon15.png';
  import iconpms from '@/assets/default-image/iconpms.png';
  import { mapState } from 'vuex'

  export default {
    name: 'LyDefaultImage',
    props: {
      src: String,
      id: String
    },
    computed: mapState({api: state => state.api}),
    data () {
      return {
        imageSrc: '',
        defaultImages: {
          1: icon1,
          2: icon2,
          3: icon3,
          4: icon4,
          5: icon5,
          6: icon6,
          7: icon7,
          8: icon8,
          9: icon9,
          10: icon10,
          11: icon11,
          13: icon13,
          14: icon14,
          15: icon15,
          pms: iconpms,
        },
      }
    },
    created() {
      this.imageSrc = (this.src!==null && this.src!=='null') ? this.api.BASE_API + this.src : this.defaultImages[this.id];
    },
    mounted () {
      this.$nextTick(() => {
        this.$refs.img.onerror = () => {
          this.imageSrc = this.defaultImages[this.id];
        }
      })
    },
  }
</script>




// WEBPACK FOOTER //
// src/components/default-image/index.vue